import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Inline, dismissible language hint shown to visitors whose browser leans
 * Spanish. NOT a modal — it tucks under the listing header so it never blocks
 * the page and is easy to ignore for English visitors. Shown at most once
 * per visitor (dismissal persisted in localStorage).
 */
export default function LanguagePromptBanner() {
  const { shouldShowBanner, setLang, dismissBanner } = useLanguage();

  return (
    <AnimatePresence>
      {shouldShowBanner && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.25 }}
          className="relative rounded-xl border border-[#F4B41A]/30 bg-gradient-to-r from-[#F4B41A]/[0.08] via-[#0F172A] to-[#F4B41A]/[0.05] px-4 py-3 sm:px-5 sm:py-3.5"
          data-testid="language-prompt-banner"
          role="status"
        >
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-start gap-3 min-w-0">
              <span className="text-2xl" aria-hidden>🇲🇽</span>
              <div className="min-w-0">
                <p className="text-white font-semibold text-sm sm:text-base leading-snug">
                  Esta empresa también está disponible en Español
                </p>
                <p className="text-[#94A3B8] text-xs sm:text-sm mt-0.5">
                  This business is also available in Spanish.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <button
                type="button"
                onClick={() => setLang("es")}
                className="rounded-full px-4 py-1.5 text-sm font-semibold bg-gradient-to-r from-[#F4B41A] to-[#E0A015] text-[#0A0F1C] hover:opacity-90 transition-opacity"
                data-testid="lang-banner-switch-es"
              >
                Ver en Español
              </button>
              <button
                type="button"
                onClick={() => setLang("en")}
                className="rounded-full px-3 py-1.5 text-sm font-medium text-[#94A3B8] hover:text-white transition-colors"
                data-testid="lang-banner-keep-en"
              >
                Keep English
              </button>
              <button
                type="button"
                onClick={dismissBanner}
                className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-[#94A3B8] hover:text-white transition-colors"
                aria-label="Dismiss"
                data-testid="lang-banner-dismiss"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
